import React from "react";

import { CSSObject } from "@emotion/serialize";
import { styled } from "@mui/material";

import { cls } from "../../../../util";

interface BarProps {
  className?: string;
  innerCss?: CSSObject;
  children?: React.ReactNode;
}

export const Bar = (props: BarProps) => {
  const { children, className, innerCss } = props;

  return (
    <Outer className={cls("ig-dp-row-2", className)}>
      <Inner className={"ig-dp-row-container"} innerCss={innerCss}>
        {children}
      </Inner>
    </Outer>
  );
};

const Outer = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "center",
});

const Inner = styled("div")(({ innerCss }: { innerCss?: CSSObject }) => ({
  display: "flex",
  width: "100%",
  alignItems: "center",
  position: "relative",
  justifyContent: "start",
  margin: 0,
  ...innerCss,
}));
